/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waiting_List_ErrorInputs */

const en_waiting_list_error = /** @type {(inputs: Waiting_List_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to add application to waiting list`)
};

const de_waiting_list_error = /** @type {(inputs: Waiting_List_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Hinzufügen der Bewerbung zur Warteliste`)
};

/**
* | output |
* | --- |
* | "Failed to add application to waiting list" |
*
* @param {Waiting_List_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const waiting_list_error = /** @type {((inputs?: Waiting_List_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waiting_List_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_waiting_list_error(inputs)
	return en_waiting_list_error(inputs)
});